/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import FormInput from "../../components/forms/form-Input";
import { useGetCurrencyDetails } from "../../services/currency-api";

export default function CurrencyDetails() {
  const params = useParams();

  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: gettingDetails,
    reset: detailsReset,
  } = useGetCurrencyDetails();
  const {
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  useEffect(() => {
    if (params.currencyId) {
      getDetails(params.currencyId);
    }
  }, []);
  useEffect(() => {
    if (detailsRes) {
      const _res = detailsRes.data;

      reset({ ..._res });
      detailsReset();
    }
  }, [detailsRes]);

  const generalFieldProps = { errors, control };

  return (
    <>
      {gettingDetails ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Currencies", link: Paths.currency },
            { text: "Currency Details", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                }}
              >
                <Heading>Currency Details</Heading>
                <Button
                  as={Link}
                  to={`${Paths.currencyEdit}/${params.currencyId || watch("id")}`}
                >
                  Edit Currency
                </Button>
              </div>

              <form className="add-location-form">
                <FormInput
                  {...generalFieldProps}
                  label="Name"
                  name="name"
                  inputProps={{ readOnly: true }}
                />

                <FormInput
                  {...generalFieldProps}
                  label="Short Name"
                  name="shortName"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Symbol"
                  name="symbol"
                  inputProps={{ readOnly: true }}
                />

                <FormInput
                  {...generalFieldProps}
                  label="Type"
                  name="type"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Sequence"
                  name="sequence"
                  inputProps={{ readOnly: true }}
                />
                <Heading
                  style={{ fontSize: "16px", margin: "12px 0", width: "100%" }}
                >
                  Multiples
                </Heading>
                <Grid data={watch("multiples") || []}>
                  <GridColumn title="Value" field="value" />
                  <GridColumn title="Shape" field="shape" />
                </Grid>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
